import React from 'react';

export default class AsyncActionComponent extends React.Component {
    actionPending = false;
    actionDisposed = false;
    actionTimer = null;
    finishCooldown = null;

    isActionPending = () => this.actionPending || this.actionDisposed;

    runAction = async (action) => {
        if (this.isActionPending()) return;
        this.actionPending = true;
        this.setState({actionPending: true});

        try {
            return await action();
        } catch (error) {
            if (!this.actionDisposed && this.props.showMessage) {
                this.props.showMessage(error && error.message ? error.message : 'Не удалось выполнить операцию');
            }
        } finally {
            if (!this.actionDisposed) {
                await new Promise(resolve => {
                    this.finishCooldown = resolve;
                    this.actionTimer = setTimeout(resolve, 2000);
                });
                this.actionTimer = null;
                this.finishCooldown = null;
                if (!this.actionDisposed) {
                    this.actionPending = false;
                    this.setState({actionPending: false});
                }
            }
        }
    };

    componentWillUnmount() {
        this.actionDisposed = true;
        clearTimeout(this.actionTimer);
        if (this.finishCooldown) this.finishCooldown();
    }
}
